import {
  Injectable,
  ComponentRef,
  ComponentFactory,
  ComponentFactoryResolver,
  Injector,
  ApplicationRef
} from '@angular/core';

import { NotificationComponent } from '../notification.component';

import { NotificationRef } from '../models/notification-ref.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationComponentFactoryService {

  constructor(
    private _injector: Injector,
    private _applicationRef: ApplicationRef,
    private _componentFactoryResolver: ComponentFactoryResolver
  ) { }

  loadNotification(options) {

    let _notificationCmp: ComponentFactory<NotificationComponent>;
    let notificationRefOptions: NotificationRef;

    _notificationCmp = this._componentFactoryResolver.resolveComponentFactory(NotificationComponent);

    const containerSelector = 'body';
    const containerEl = document.querySelector(containerSelector);

    if (!containerEl) {
      throw new Error('Body does not exist in DOM.');
    }

    let notificationCmptRef: ComponentRef<NotificationComponent>;

    notificationCmptRef = _notificationCmp.create(this._injector);
    this._applicationRef.attachView(notificationCmptRef.hostView);
    containerEl.appendChild(notificationCmptRef.location.nativeElement);

    notificationCmptRef.instance['options'] = options;
    notificationRefOptions = new NotificationRef(notificationCmptRef);

    return notificationRefOptions;
  }
}
